document.addEventListener('DOMContentLoaded', function () {
  initProductSwipers(document);

  // For theme editor section reloads
  document.addEventListener('shopify:section:load', function (event) {
    const container = event.target;
    if (
      container.matches('[data-section-type="product"]') ||
      container.querySelector('[data-section-type="product"]')
    ) {
      initProductSwipers(container);
    }
  });
});

function initProductSwipers(root) {
  const scope = root || document;
  const sections = scope.querySelectorAll('[data-section-type="product"]');
  if (!sections.length) return;

  sections.forEach(function (section) {
    const mainEl = section.querySelector('[data-product-slideshow]');
    const thumbsEl = section.querySelector('[data-product-thumbs]');
    if (!mainEl || !thumbsEl) return;

    // Prevent double initialization
    if (mainEl.classList.contains('swiper-initialized')) return;

    // Configuration from data attributes
    const transition = section.getAttribute('data-transition') || 'slide';
    const thumbsLayout = section.getAttribute('data-thumbs-layout') || 'responsive';
    const mobilePeek = section.getAttribute('data-mobile-peek') === 'true';

    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const useVerticalThumbs =
      thumbsLayout === 'vertical' ||
      (thumbsLayout === 'responsive' && !isMobile);

    // ===== MAIN SWIPER DOM SETUP =====
    const mainSlides = Array.from(
      mainEl.querySelectorAll('.product__media')
    );
    if (!mainSlides.length) return;

    mainEl.classList.add('swiper', 'product-swiper-main');

    const mainWrapper = document.createElement('div');
    mainWrapper.classList.add('swiper-wrapper');

    mainSlides.forEach(function (slide) {
      slide.classList.add('swiper-slide');
      mainWrapper.appendChild(slide);
    });

    mainEl.innerHTML = '';
    mainEl.appendChild(mainWrapper);

    // ===== THUMBNAILS SWIPER DOM SETUP =====
    const thumbSlides = Array.from(
      thumbsEl.querySelectorAll('.media__thumb')
    );
    if (!thumbSlides.length) return;

    thumbsEl.classList.add('swiper', 'product-swiper-thumbs');

    const thumbsWrapper = document.createElement('div');
    thumbsWrapper.classList.add('swiper-wrapper');

    thumbSlides.forEach(function (thumb, index) {
      thumb.classList.add('swiper-slide');
      thumb.setAttribute('data-thumb-index', index);
      thumbsWrapper.appendChild(thumb);
    });

    thumbsEl.innerHTML = '';
    thumbsEl.appendChild(thumbsWrapper);

    // ===== INITIALIZE THUMBNAILS SWIPER =====
    const thumbsSwiper = new Swiper(thumbsEl, {
      direction: useVerticalThumbs ? 'vertical' : 'horizontal',
      spaceBetween: 5,
      slidesPerView: 4, // Fixed number for mobile
      freeMode: true, // Keep freeMode enabled for scrolling
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      mousewheel: useVerticalThumbs,
      slideToClickedSlide: true,
      breakpoints: {
        768: {
          direction: useVerticalThumbs ? 'vertical' : 'horizontal',
          slidesPerView: useVerticalThumbs ? 5 : 4,
          freeMode: useVerticalThumbs ? false : true,
        },
        1024: {
          slidesPerView: useVerticalThumbs ? 5 : 'auto',
        }
      },
      on: {
        click: function(swiper) {
          const clickedIndex = swiper.clickedIndex;
          if (typeof clickedIndex !== 'undefined' && clickedIndex >= 0) {
            mainSwiper.slideToLoop(clickedIndex);
          }
        }
      }
    });

    // ===== INITIALIZE MAIN SWIPER =====
    const mainSwiperOpts = {
      spaceBetween: 10,
      loop: true,
      thumbs: {
        swiper: thumbsSwiper,
      },
      on: {
        slideChange: function() {
          updateActiveThumbnail(this.realIndex);
        },
        init: function() {
          updateActiveThumbnail(this.realIndex);
        }
      }
    };

    // Configure transition effect
    if (transition === 'fade') {
      mainSwiperOpts.effect = window.matchMedia('(min-width: 768px)').matches ? 'fade' : 'slide';
      mainSwiperOpts.fadeEffect = { crossFade: true };
    } else {
      mainSwiperOpts.effect = 'slide';
    }

    // Mobile peek configuration
    if (isMobile && mobilePeek) {
      mainSwiperOpts.slidesPerView = 1.15;
      mainSwiperOpts.centeredSlides = false;
    } else {
      mainSwiperOpts.slidesPerView = 1;
    }

    const mainSwiper = new Swiper(mainEl, mainSwiperOpts);

    // ===== UPDATE ACTIVE THUMBNAIL WITH SCROLL =====
    function updateActiveThumbnail(index) {
      if (!thumbsSwiper || !thumbsSwiper.slides) return;

      // Update active classes
      thumbsSwiper.slides.forEach((slide, idx) => {
        if (idx === index) {
          slide.classList.add('thumb-active');
        } else {
          slide.classList.remove('thumb-active');
        }
      });

      // Calculate if we need to scroll to make the thumbnail visible
      const activeThumb = thumbsSwiper.slides[index];
      if (!activeThumb) return;

      const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' 
        ? 4 
        : thumbsSwiper.params.slidesPerView;
      
      const totalSlides = thumbsSwiper.slides.length;
      
      // Only scroll if we have more slides than visible
      if (totalSlides > slidesPerView) {
        let slideToIndex = 0;
        
        // Calculate the optimal position
        if (index <= 1) {
          // Near beginning - show from start
          slideToIndex = 0;
        } else if (index >= totalSlides - slidesPerView + 1) {
          // Near end - show last set
          slideToIndex = totalSlides - slidesPerView;
        } else {
          // Middle - center if possible
          slideToIndex = Math.max(0, index - Math.floor(slidesPerView / 2));
        }
        
        // Use slideTo to smoothly scroll
        thumbsSwiper.slideTo(slideToIndex, 300);
      }
    }

    // ===== MANUAL NAVIGATION BUTTONS (if they exist) =====
    const prevButton = section.querySelector('.swiper-button-prev');
    const nextButton = section.querySelector('.swiper-button-next');
    
    if (prevButton) {
      prevButton.addEventListener('click', function() {
        mainSwiper.slidePrev();
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', function() {
        mainSwiper.slideNext();
      });
    }

    // ===== KEYBOARD NAVIGATION =====
    mainEl.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') {
        mainSwiper.slidePrev();
      } else if (e.key === 'ArrowRight') {
        mainSwiper.slideNext();
      }
    });

    // ===== RESPONSIVE BEHAVIOR =====
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        const newIsMobile = window.matchMedia('(max-width: 767px)').matches;
        const newUseVerticalThumbs =
          thumbsLayout === 'vertical' ||
          (thumbsLayout === 'responsive' && !newIsMobile);

        if (useVerticalThumbs !== newUseVerticalThumbs) {
          // Destroy and reinitialize on layout change
          if (mainSwiper) mainSwiper.destroy(true, true);
          if (thumbsSwiper) thumbsSwiper.destroy(true, true);
          initProductSwipers(section);
        } else {
          // Just update the swipers
          if (mainSwiper) mainSwiper.update();
          if (thumbsSwiper) thumbsSwiper.update();
        }
      }, 250);
    });
  });
}